import { toPattern } from "@/utils/Prototypes/PString";
import { NetworkService } from "./NetworkService";
import { SubscriptionService } from "./SubscriptionService";

export default class UserService {
  network;
  constructor(ntw: NetworkService) {
    this.network = ntw;
  }

  static PROFESSIONAL_TYPES = {
    doctor: "Médico",
    dentist: "Dentista",
    other: "Outro",
  };

  static USER_TYPE = {
    admin: "Administrador",
    professional: "Profissional",
    student: "Estudante",
  };

  list = async (filters) => {
    const res = await this.network.get(this.network.endpoints.users, filters);
    res.data = res.data.map((user) => this.prepareUser(user));
    return res;
  };
  create = (params) => {
    return this.network.post(this.network.endpoints.users, params);
  };
  update = (id, params) => {
    return this.network.put(`${this.network.endpoints.users}/${id}`, params);
  };
  show = async (id, params) => {
    const res = await this.network.get(`${this.network.endpoints.users}/${id}`, params);
    res.data = this.prepareUser(res.data);
    return res;
  };
  delete = (id) => {
    return this.delete(`${this.network.endpoints.users}/${id}`);
  };
  login = async (params) => {
    let res = await this.network.post(this.network.endpoints.login, params);
    if (res.data.type == "admin") {
      return res;
    } else {
      throw { status: false, message: "Credenciais inválidas" };
    }
  };
  forgotPassword = (params) => {
    return this.network.post(this.network.endpoints.forgotPassword, params);
  };
  logout = () => {
    return this.network.put(`${this.network.endpoints.users}/logout`);
  };
  settings = (key) => {
    return this.network.get(`${this.network.endpoints.settings}/${key}`);
  };
  updateSettings = (key, value) => {
    return this.network.put(`${this.network.endpoints.settings}/${key}`, {
      value,
    });
  };
  homeInfo = () => {
    return this.network.get(`${this.network.endpoints.homeInfo}`);
  };
  listCrashes = () => {
    return this.network.get(`${this.network.endpoints.appCrashes}`);
  };
  showCrash = (id) => {
    return this.network.get(`${this.network.endpoints.appCrashes}/${id}`);
  };
  planDetails = (params) => {
    return this.network.get(`${this.network.endpoints.planDetails}`, params);
  };
  subscribeUser = (params) => {
    return this.network.post(this.network.endpoints.subscribeUser, params);
  };
  unsubscribeUser = (params) => {
    return this.network.post(this.network.endpoints.unsubscribeUser, params);
  };
  sendNotification = (params) => {
    return this.network.post(`${this.network.endpoints.sendNotification}`, params);
  };
  sendEmail = (params) => {
    return this.network.post(`${this.network.endpoints.sendEmail}`, params);
  };
  prepareUser = (data) => {
    const subsService = new SubscriptionService();

    const hasActiveStripeSubs =
      data.subs &&
      (data.subs.stripe_status === "active" ||
        data.subs.stripe_status === "trialing");

    const hasActiveIAPSubs =
      data.inapp_subs &&
      (data.inapp_subs.plan_status === "paid" ||
        data.inapp_subs.plan_status === "trial");

    data.isPremium = hasActiveIAPSubs || hasActiveStripeSubs;
    data.account_type = UserService.USER_TYPE[data.type];
    data.professionalType =
      UserService.PROFESSIONAL_TYPES[data.professional_type];
    data.subscriptionConfig = hasActiveIAPSubs
      ? subsService.prepareSubscriptionForIAP(data.inapp_subs)
      : data.subs
        ? subsService.prepareSubscriptionForStripe(data.subs)
        : null;

    let formattedPhone = ''
    if (data.phone) {
      formattedPhone = toPattern(`${data.area_phone}${data.phone}`, "phone",
        "(##) #####-####",)
    }
    data.formattedPhone = formattedPhone

    return data;
  };

  listFeedback = () => {
    return this.network.get(this.network.endpoints.feedback);
  };

  dashboardGeneral = (params = {}) => {
    return this.network.get(this.network.endpoints.dashboardGeneral, params);
  };

  dashboardUsage = (params = {}) => {
    return this.network.get(this.network.endpoints.dashboardUsage, params);
  };

  dashboardChurn = (params = {}) => {
    return this.network.get(this.network.endpoints.dashboardChurn, params);
  };

  dashboardFinances = (params = {}) => {
    return this.network.get(this.network.endpoints.dashboardFinances, params);
  };

  listCRMs = (id) => {
    return this.network.get(this.network.endpoints.userCrm, { user_id: id });
  };

  updateCRM = (id, params) => {
    return this.network.put(`${this.network.endpoints.userCrm}/${id}`, params);
  };
}
